import React, { useState, useRef, useCallback } from 'react';
import {
  useNavigate,
  useSearchParams,
  useLocation,
  useParams,
} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as modalActions from '../../redux/actions/modal-actions';
import * as drawerActions from '../../redux/actions-v2/drawer-actions';
import { useTranslation } from 'react-i18next';
import * as Icons from '@mui/icons-material';
import { motion } from 'framer-motion';
import {
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SideBar = ({
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { pathname: currentPath } = useLocation();
  const { moduleId, structureId } = useParams();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const businessStructure = useSelector(
    (state) => state.core.businessStructure
  );
  const businessPreference = useSelector((state) => state.core.businessData);
  const singleElementDetails = useSelector(
    (state) => state.element.singleElementDetails
  );


  const activeModule = businessStructure?.modules?.find((m) => m.id === moduleId);
  const activeStructure = businessStructure?.structures?.find((s) => s.id === structureId);

  const InnerShadowIconButton = React.forwardRef(
    ({ icon, onClick, disabled, noMargin, transparent, ...props }, ref) => {
      const IconComponent = Icons[icon] || Icons.Error;

      return (
        <span>
          <IconButton
            ref={ref}
            {...props}
            size="large"
            edge="start"
            color="black"
            onClick={typeof onClick === 'function' ? onClick : undefined}
            disabled={disabled}
            sx={{
              borderRadius: '6px',
              backgroundColor: transparent
                ? 'transparent'
                : isDarkMode
                  ? '#00000090'
                  : '#FFFFFF95',
              padding: '0px',
              height: '36px',
              minHeight: '36px',
              marginBottom: '18px',
              width: '36px',
              maxHeight: '36px',
              position: 'relative',
              '& svg': {
                position: 'relative',
                zIndex: 2,
              },
            }}
          >
            <IconComponent color={isDarkMode ? 'white' : 'black'} />
          </IconButton>
        </span>
      );
    }
  );

  const handleConnectors = useCallback(() => {
    dispatch(modalActions.modalStoreConnector({ isOpen: true }));
  }, [dispatch]);

  const handleProfile = useCallback(() => {
    dispatch(modalActions.modalEvolutionSheet({ isOpen: true }));
  }, [dispatch]);

  const handleAgenda = useCallback(() => {
    dispatch(drawerActions.sidebarAgenda({ isDrawerOpen: true, show: true }));
  }, [dispatch]);

  const handleNodeAI = useCallback(() => {
    dispatch(drawerActions.sidebarNodeAI({ isDrawerOpen: true, show: true }));
  }, [dispatch]);

  return (
    <div>

      <motion.div whileHover={{ scale: 1.2 }}>
        <Tooltip title={t('agenda')}>
          <span>
            <InnerShadowIconButton
              icon="CalendarMonthOutlined"
              onClick={handleAgenda}

            />
          </span>
        </Tooltip>
      </motion.div>
      {activeStructure?.collectionField === 'cardsuninvoiced' && (
        <motion.div whileHover={{ scale: 1.2 }}>
          <Tooltip title={t('evolutionSheet')}>
            <span>
              <InnerShadowIconButton
                icon="TrackChangesOutlined"
                onClick={handleProfile}

              />
            </span>
          </Tooltip>
        </motion.div>)}
      {activeStructure?.collectionField === 'cardsuninvoiced' && (
        <motion.div whileHover={{ scale: 1.2 }}>
          <Tooltip title={t('connectors')}>
            <span>
              <InnerShadowIconButton
                icon="ExtensionOutlined"
                onClick={handleConnectors}

              />
            </span>
          </Tooltip>
        </motion.div>
      )}
      {activeStructure?.collectionField === 'contacts' && (
        <motion.div whileHover={{ scale: 1.2 }}>
          <Tooltip title={t('nodeAI')}>
            <span>
              <InnerShadowIconButton
                icon="AssistantOutlined"
                onClick={handleNodeAI}

              />
            </span>
          </Tooltip>
        </motion.div>)}
    </div>
  );
};

export default SideBar;
